import React from "react";
import { connect } from "react-redux";
import { FormikProps } from "formik/dist/types";
import InputText from "../../inputs/InputText";
import {getPlaceholderForTextFieldConfiguration, hasBeenFilled} from "../../../../helpers/dynamicFormHelper";
import {TextSearchFieldType} from "../../../../types/configurations";

interface PropsType {
  fieldConfigurations: TextSearchFieldType,
  disabled: boolean,
  forceDisabled: boolean,
  changeFilterDispatchActionHandler: any,
  formProps: FormikProps<any>,
  language: string
}

const TextSearchField = (props: PropsType) => {
  const {
    fieldConfigurations,
    disabled,
    forceDisabled,
    changeFilterDispatchActionHandler,
    formProps: {
      values
    },
    language
  } = props;

  const isInputDisabled = forceDisabled || (disabled);

  const onChangeHandler = (event) => {
    const {value} = event.target;
    changeFilterDispatchActionHandler(fieldConfigurations.name, value);
  };

  return (
    <InputText
      name={fieldConfigurations.name}
      allowClear={!isInputDisabled}
      onChange={onChangeHandler}
      className="m-0 form-control"
      placeholder={getPlaceholderForTextFieldConfiguration(fieldConfigurations, language)}
      defaultValue={values[fieldConfigurations.name] || ""}
      disabled={isInputDisabled}
    />
  );
};

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language
});

export default connect(mapStateToProps)(TextSearchField);
